import '@operato/dataset/ox-data-ooc-brief-view.js'

import gql from 'graphql-tag'
import { css, html, LitElement } from 'lit'
import { customElement, property, query, state } from 'lit/decorators.js'

import { client } from '@operato/graphql'
import { i18next, localize } from '@operato/i18n'
import { ScrollbarStyles } from '@operato/styles'

@customElement('activity-ooc-resolve-view')
export class OocResolveActivityView extends localize(i18next)(LitElement) {
  static styles = [
    ScrollbarStyles,
    css`
      :host {
        display: flex;
        flex-direction: column;

        background-color: var(--md-sys-color-surface);
      }

      div[content] {
        flex: 1;
        flex-direction: column;

        display: flex;
        overflow: auto;
      }

      ox-data-ooc-brief-view {
        flex: 1;
        padding: var(--spacing-large);
        overflow: auto;
      }

      @media print {
        :host {
          display: block;
          overflow: visible;
        }

        div[content] {
          display: block;
          overflow: visible;
        }
      }
    `
  ]

  @property({ type: Object }) input?: any
  @property({ type: Object }) output?: any
  @property({ type: Object }) activityApproval?: any

  @state() dataOoc?: any

  render() {
    return html`
      <div content>
        <ox-data-ooc-brief-view .dataOoc=${this.dataOoc}></ox-data-ooc-brief-view>
      </div>
    `
  }

  updated(changes) {
    if (changes.has('input')) {
      this.fetchDataOoc()
    }
  }

  async fetchDataOoc() {
    const id = this.input.dataOocId

    if (id) {
      const response = await client.query({
        query: gql`
          query ($id: String!) {
            dataOoc(id: $id) {
              id
              name
              description
              ooc
              oos
              state
              type
              useCase
              data
              judgment
              history
              correctiveAction
              correctiveInstruction
              dataSet {
                id
                name
                monitorType
                monitorView
              }
              dataItems {
                name
                description
                active
                hidden
                tag
                group
                subgroup
                type
                unit
                options
                quota
                spec
                stat
              }
              workDate
              workShift
              reviewer {
                id
                name
              }
              corrector {
                id
                name
              }
              collectedAt
              reviewedAt
              correctedAt
            }
          }
        `,
        variables: {
          id
        }
      })

      const dataOoc = {
        ...response.data.dataOoc
      }

      const activityThread = this.activityApproval?.activityThread

      if (activityThread?.output) {
        /* approval 에서 사용되는 경우 corrective 관련정보를 보완한다. - approval과정에서는 아직 dataOoc.correctiveAction 정보는 채워지지 않았기 때문. */
        dataOoc.correctiveAction = activityThread.output.action
        dataOoc.correctedAt = activityThread.updatedAt
        dataOoc.corrector = activityThread.assignee
      }

      this.dataOoc = dataOoc
    }
  }
}
